(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  function getVisibleImage(media) {
    var desktop = media.querySelector('.simple-image-with-text__img--desktop');
    var mobile = media.querySelector('.simple-image-with-text__img--mobile');
    if (isMobile()) return mobile || desktop;
    return desktop || mobile;
  }

  function applyAspectRatio(media) {
    if (media.getAttribute('data-siwt-fit') === 'original') return;
    if (media.getAttribute('data-siwt-ratio')) return;

    var img = getVisibleImage(media);
    if (!img) return;

    function applyFromImage() {
      if (img.naturalWidth && img.naturalHeight) {
        media.style.setProperty(
          '--siwt-aspect-ratio',
          img.naturalWidth + ' / ' + img.naturalHeight
        );
      }
    }

    if (img.complete) {
      applyFromImage();
    } else {
      img.addEventListener('load', applyFromImage, { once: true });
    }
  }

  function isCarouselActive(section) {
    if (!section) return false;
    var layout = isMobile()
      ? section.getAttribute('data-siwt-layout-mobile')
      : section.getAttribute('data-siwt-layout-desktop');
    return layout === 'carousel';
  }

  function initSection(section) {
    if (!section) return;
    section.querySelectorAll('[data-siwt-media]').forEach(applyAspectRatio);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-simple-image-with-text]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target;
    if (!item || !item.classList.contains('simple-image-with-text__item')) return;
    var section = item.closest('[data-simple-image-with-text]');
    if (!isCarouselActive(section)) return;
    item.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  });

  window.addEventListener('resize', function () {
    initAll();
  });
})();
